import { Helmet } from 'react-helmet-async';
// routes
import { useParams } from 'src/routes/hooks';
// sections
import { InterviewEditView } from 'src/sections/interview/view';

// ----------------------------------------------------------------------

export default function InterviewEditPage() {
  const params = useParams();

  const { id } = params;

  return (
    <>
      <Helmet>
        <title> Hireintel - Interview Edit Page</title>
      </Helmet>

      <InterviewEditView interviewId={`${id}`} />
    </>
  );
}
